<template>
  <div id="app">
    <FD-Header></FD-Header>
    <div class="main">
      <router-view/>
    </div>
    <FD-Footer></FD-Footer>
    <a-back-top />
  </div>
</template>
<script>
import Header from './layouts/Header'
import Footer from './layouts/Footer'

export default {
  components: {
    'FD-Header': Header,
    'FD-Footer': Footer
  }
}
</script>
<style lang="scss">
  @import './scss/base/_base';
</style>
